// @ts-nocheck
import useAccount from "classes/Accounts/hooks/useAccount";
import FormAnswerModel from "classes/Forms/FormAnswerModel";
import getQuestionsTypes from "classes/Forms/QuestionsTypes";
import TagLabel from "components/Tags/Label/TagLabel";
import { linkify } from "includes/linkify";
import { t } from "i18next";
import React, { useState } from "react";

export default function FormQuestion(props) {
	const { account } = useAccount();
	const { isActive, refreshForm } = props;
	const { question } = props;
	const AnswerRequired = question.answerRequired;
	const [Answers, setAnswers] = useState(question.answers || []);

	function handleUpdate() {
		if (refreshForm) refreshForm();
	}

	function getType(typeId) {
		let QTypes = getQuestionsTypes();
		let found = QTypes.find((a) => a.questionDesignId === typeId);
		return found ? found : false;
	}

	function selectAnswers(values) {
		question.answers = values.map((a) => {
			a.employeeId = account.employeeId;
			return a instanceof FormAnswerModel
				? a
				: new FormAnswerModel(a, this);
		});
		setAnswers(values);
	}

	return (
		<div
			className={
				"FormQuestion" +
				(AnswerRequired ? " requiered" : "") +
				(isActive ? " active" : "")
			}
			data-form-question-id={question.questionId}
		>
			<div className="d-flex flex-column w-100 mb-2">
				<div className="col-12 pr-0">
					{question.answerRequired && (
						<div className="d-flex mb-2">
							<TagLabel
								className="required-tag"
								color={"red"}
								text={t("Forms.REQUIERED")}
							/>
						</div>
					)}
					{question.imgUrl && (
						<div className="question-image d-flex justify-content-center mb-2">
							<img
								alt={(question.title || question.title)}
								style={{
									maxHeight: "60vh",
									width: "auto",
									maxWidth: "100%",
								}}
								src={question.imgUrl}
							/>
						</div>
					)}
					<div className="question-title">{(question.title || question.title)}</div>
					<div className="question-text mt-1">
						{linkify(question.txt || question.txt)}
					</div>
				</div>
			</div>
			<div className="question-options-cont">
				<AnswersList
					question={question}
					options={question.options || question.options || []}
					setAnswers={selectAnswers}
					answers={Answers}
					type={getType(question.questionDesignId)}
					handleUpdate={handleUpdate}
				/>
			</div>
		</div>
	);
}

function AnswersList({
	question,
	options,
	type,
	handleUpdate,
	setAnswers,
	answers,
}) {
	function isSelected(optionId) {
		if (!answers?.length) return false;
		let found = answers.find((a) => a.optionId === optionId);
		return found ? found : false;
	}

	function handleChange(val) {
		if (val.unique || type.uniqueChoice) return setAnswers([val]);
		let dup = [...answers];
		for (let x in answers) {
			let ans = answers[x];
			if (ans.optionId === val.optionId) {
				if (!val.state) {
					dup.splice(x, 1);
					setAnswers(dup);
				}
				return dup;
			}
		}
		dup.push(val);
		setAnswers(dup);
	}

	if (!options.length) return false;

	return (
		<div className="AnswersList mt-2">
			{options.map((a, key) => {
				if (!type?.filler) return null;
				let option_ans = isSelected(a.optionId);
				return (
					<type.filler
						index={key}
						handleUpdate={handleUpdate}
						unique={type.uniqueChoice}
						key={a.optionId}
						question={question}
						option={a}
						type={type}
						onChange={handleChange}
						selected={option_ans}
						isSelected={isSelected}
						answers={answers}
					/>
				);
			})}
		</div>
	);
}
